export default __webpack_public_path__ + "static/media/successIcon.c910914f.svg";